import { useCallback } from "react";
import type { ButtonHTMLAttributes } from "react";
import { cn } from "../../../utils/cn";

export interface SwitchProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> {
  checked: boolean;
  onCheckedChange?: (checked: boolean) => void;
  label?: string;
}

export function Switch({ checked, onCheckedChange, label, className, ...props }: SwitchProps) {
  const onClick = useCallback(() => onCheckedChange?.(!checked), [onCheckedChange, checked]);
  return (
    <button
      role="switch"
      aria-checked={checked}
      aria-label={label}
      onClick={onClick}
      className={cn(
        "inline-flex h-5 w-9 items-center rounded-full border transition-colors",
        checked ? "bg-accent border-accent" : "bg-surface border-muted",
        className,
      )}
      {...props}
    >
      <span
        className={cn(
          "ml-0.5 inline-block h-4 w-4 transform rounded-full bg-bg transition-transform",
          checked ? "translate-x-4" : "translate-x-0",
        )}
      />
    </button>
  );
}

export default Switch;
